module.exports = __webpack_public_path__ + "static/media/download.e9af4a2a.mp3";